import { UpperCasePipe } from '@angular/common';
import { Component, input, output, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FeatureMasterViewComponent } from '@iot-platform/feature/master-view';
import { TranslatePipe } from '@ngx-translate/core';
import { BUSINESS_PROFILE_GRIDS_MASTER_VIEW_NAME } from './business-profile-grids-grid-definition';

@Component({
  imports: [
    FlexLayoutModule,
    MatCardModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    MatMenuModule,
    TranslatePipe,
    UpperCasePipe,
    MatTooltipModule,
    FeatureMasterViewComponent
  ],
  selector: 'iot4bos-ui-backoffice-business-profile-grids-tab',
  templateUrl: './business-profile-grids-tab.component.html',
  styleUrls: ['./business-profile-grids-tab.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.Emulated
})
export class BusinessProfileGridsTabComponent {
  canUpdateBusinessProfile = input<boolean>(false);
  masterViewList = input<string[]>([]);

  addGrid = output<string>();

  readonly businessProfileGridsMasterViewName = BUSINESS_PROFILE_GRIDS_MASTER_VIEW_NAME;
}
